export default "__VITE_ASSET__Dq5y1EMp__"